module.exports = __webpack_public_path__ + "static/img/pf-2.bdba19e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/newYearActivity/pf-2.png
// module id = ARRN
// module chunks = 2